import { Menu } from "primereact/menu";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthUser } from "../../auth/AuthService";

const AppSidebar = () => {
    const path = window.location.pathname.split("/")[2];
    const {t} = useTranslation();
    const authUser = useAuthUser();
    const items = [
        {
            label: t('USERS AND GROUPS'),
            items: [
                {
                    template: () => {
                        return (
                            <Link to='/admin/user-statistic' className={(path === 'user-statistic'? 'font-bold text-blue-500' : '') + ' p-menuitem-link'}><i className="pi pi-users pr-2"></i>{t("Users' Statistic")}</Link>
                        )
                    }
                },
                {
                    template: () => {
                        return (
                            <Link to='/admin/user' className={(path === 'user'? 'font-bold text-blue-500' : '') + ' p-menuitem-link'}><i className="pi pi-users pr-2"></i>{t('All Users')}</Link>
                        )
                    }
                },
                {
                    template: () => {
                        return (
                            <Link to='/admin/online-user' className={(path === 'online-user'? 'font-bold text-blue-500' : '') + ' p-menuitem-link'}><i className="pi pi-user pr-2"></i>{t('Online Users')}</Link>
                        )
                    }
                },
                {
                    template: () => {
                        return (
                            <Link to='/admin/group' className={(path === 'group'? 'font-bold text-blue-500' : '') + ' p-menuitem-link'}><i className="pi pi-sitemap pr-2"></i>{t('Groups')}</Link>
                        )
                    }
                }
            ]
        },
        {
            label: t('FIRMS AND STOCKS'),
            items: [
                {
                    template: () => {
                        return (
                            <Link to='/admin/firm' className={(path === 'firm'? 'font-bold text-blue-500' : '') + ' p-menuitem-link'}><i className="pi pi-briefcase pr-2"></i>{t('Firms')}</Link>
                        )
                    }
                },
                {
                    template: () => {
                        return (
                            <Link to='/admin/stock' className={(path === 'stock'? 'font-bold text-blue-500' : '') + ' p-menuitem-link'}><i className="pi pi-money-bill pr-2"></i>{t('Stocks')}</Link>
                        )
                    }
                }
            ]
        },
        {
            label: t('SETTING'),
            items: [
                {
                    template: () => {
                        return (
                            <Link to='/admin/menu' className={(path === 'menu'? 'font-bold text-blue-500' : '') + ' p-menuitem-link'}><i className="pi pi-bars pr-2"></i>{t('Menus')}</Link>
                        )
                    }
                },
                {
                    template: () => {
                        return (
                            <Link to='/admin/calender' className={(path === 'calender'? 'font-bold text-blue-500' : '') + ' p-menuitem-link'}><i className="pi pi-calendar pr-2"></i>{t('Calender')}</Link>
                        )
                    }
                },
                {
                    template: () => {
                        return (
                            <Link to='/admin/advertise' className={(path === 'advertise'? 'font-bold text-blue-500' : '') + ' p-menuitem-link'}><i className="pi pi-megaphone pr-2"></i>{t('Advertise')}</Link>
                        )
                    }
                },
                {
                    template: () => {
                        return (
                            <Link to='/admin/user-guide' className={(path === 'user-guide'? 'font-bold text-blue-500' : '') + ' p-menuitem-link'}><i className="pi pi-map pr-2"></i>{t('Users Guide')}</Link>
                        )
                    }
                }
            ]
        }
    ];

    const itemManager = [
        {
            label: t('USERS AND GUIDELINE'),
            items: [
                {
                    template: () => {
                        return (
                            <Link to='/admin/manager/user' className={(path === 'manager'? 'font-bold text-blue-500' : '') + ' p-menuitem-link'}><i className="pi pi-users pr-2"></i>{t('Users Management')}</Link>
                        )
                    }
                },
                {
                    template: () => {
                        return (
                            <Link to='/admin/user-guide' className={(path === 'user-guide'? 'font-bold text-blue-500' : '') + ' p-menuitem-link'}><i className="pi pi-map pr-2"></i>{t('Users Guide')}</Link>
                        )
                    }
                }
            ]
        },
    ];
    let sidebarItems = items;
    if (authUser()?.role === 'manager') {
        sidebarItems = itemManager;
    }

    return (
        <>
            <Menu model={sidebarItems} />
        </>
    )
}

export default AppSidebar;